<template>
	<div class="form-option">
		<div>
			<div class="form-title">CALIFICANOS</div>
			<el-rate
				:colors="colors" 
				v-model="value"
				void-color="#2c404a">
			</el-rate>
		</div>
		<div class="form-group">
			<el-form
				:model="model"
				class="d-flex wrap"
				:rules="responsibleRules"
			>
				<el-form-item prop="description" class="flex-95 mx-1">
					<el-input
						type="textarea"
						class="qtc-input"
						rows="4"
						v-model="model.description" 
						placeholder="Describe tu experiencia"></el-input>
				</el-form-item>
				<div class="d-flex align-center space-evenly w-100">
					<button
						type="button"
						class="cancel-button"
						:style="`background-color:${globalColors.hover}`"
						@click="cancelRating"
					>Cancelar</button>
					<button 
						type="button"
						class="btn-send-opinion"
						:style="`background-color:${globalColors.primary}`"
						@click="sendOpinion"
						:class="[
							{ 'disable-btn': disabledBtn },
						]">Enviar</button>
				</div>
			</el-form>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';


function created() {
	if (this.token) {
		const dataNew = this.getUserInfo;
		this.model.name = dataNew.typePerson.fullName;
		this.model.avatar = this.$store.state.user.avatar;
	}
}

function disabledBtn() {
	return !(this.model.description && this.value);
}

async function sendOpinion() {
	if (!this.token) {
		this.$message({
			message: 'Para realizar una opinión tiene que registrarse',
			showClose: true,
			type: 'error',
		});
	} else {
		const idProduct = this.id;
		const token = this.token;
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		const body = {
			additionalInformation: {
				customerImage: this.model.avatar,
				name: this.model.name,
			},
			description: this.model.description,
			rating: this.value,
			typeQuestionAnswer: 3,
		};
		try {
			await this.$httpQtc.post(`question-answer/${idProduct}/product`, body, { headers });
			this.$message({
				message: 'Valoración registrada con éxito',
				showClose: true,
				type: 'success',
			});
			this.cancelRating();
			this.clearForm();
		} catch (error) {
			this.$message({
				message: 'Error',
				showClose: true,
				type: 'error',
			});
		}
	}
}

function clearForm() {
	this.model.description = null;
	this.value = null;
}


function setData(value) {
	if (value) {
		setTimeout(() => {
			const dataNew = this.getUserInfo;
			this.model.name = dataNew.fullName;
			this.model.avatar = this.$store.state.user.avatar;
		}, 300);
	} else {
		this.clearForm();
	}
}

function cancelRating() {
	this.$emit('cancel-rating');
}

function data() {
	return {
		value: null,
		colors: ['#2c404a', '#2c404a', '#2c404a'],
		model: {
			description: null,
			name: null,
			avatar: null,
		},
		responsibleRules: {
			description: [{ required: true, message: 'Escribe una opinión', trigger: ['blur', 'change'] }],
		},
	};
}

export default {
	name: 'form-opinion',
	data,
	computed: {
		disabledBtn,
		...mapGetters([
			'token',
			'getUserInfo',
		]),
	},
	created,
	methods: {
		cancelRating,
		clearForm,
		sendOpinion,
	},
	watch: {
		token: setData,
	},
	props: {
		id: [Number, String],
	},
};
</script>
<style lang="scss">
	.form-option {
		border-bottom: 0.1rem solid color(backGrey);
		display: flex;
		justify-content: space-between;
		margin-bottom: 5.2rem;

		.form-title {
			color: color(defaultBlack);
			font-family: font(open-semibold);
			font-size: size(medium);
			margin-bottom: 1.8rem;
		}

		.el-rate__icon {
			font-size: size(mslarge);
		}
	}

	.form-textarea-opinion {
		background: color(veryLightGrey);
		border: 0.1rem solid color(input);
		border-radius: 0.4rem;
		color: color(input-text);
		font-size: size(normal);
		height: 8.6rem;
		outline: none;
		padding: 1rem 2.4rem;
		resize: none;
		width: 100%;
	}

	.form-group {
		width: 80%;
	}

	.btn-send-opinion,
	.cancel-button {
		border: none;
		color: color(white);
		cursor: pointer;
		display: block;
		flex-basis: 20%;
		font-size: size(large);
		margin-bottom: 2rem;
		outline: none;
		padding: 1rem 3.5rem;
	}

	.cancel-button {
		background-color: color(titleGrey);
		color: white;
	}

	@media screen and (max-width: 1024px) {
		.form-option {
			border-bottom: none;
			flex-direction: column;
			margin-bottom: 0;

			.el-rate {
				height: 3.8rem;
				text-align: center;
			}

			.el-rate__icon {
				font-size: 3.7rem;
			}

			.form-title {
				margin: 0 0 1.8rem 2.4rem;
			}
		}

		.form-group {
			margin-top: 3.4rem;
			width: 100%;
		}

		.form-textarea-opinion {
			font-size: size(medium);
		}

		.btn-send-opinion,
		.cancel-button {
			font-size: size(medium);
		}
	}
</style>





// WEBPACK FOOTER //
// formOpinion.vue?28d1839d